import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';


@Component({
  selector: 'page-cek-senet-durum-degistir',
  templateUrl: 'cek-senet-durum-degistir.html',
})
export class CekSenetDurumDegistirPage {
item:any={ID:"",SonDurum:"",Aciklama:""};
DurumList=[];
kasaid:number=0;
kasalistesi=[];
aktifkullaniciadi="";

  constructor(public navCtrl: NavController,
    public bllOrtak:BllOrtak,
    public viewCtrl:ViewController,
    public ortak:Ortak,
     public navParams: NavParams) {
      if (navParams.get("items") != null) {
        this.item = navParams.get("items");
      }
      this.aktifkullaniciadi=this.ortak.aktifKullaniciAdi;

  }

  ionViewDidLoad(){
   this.DurumlariGetir();
   this.KasalariGetir();
  }
  DurumlariGetir()
  {
    this.bllOrtak.islemWithoutPost("CekSenetDurumGetir","",false).then(a=>{
      var sonuc=<any>a;
      this.DurumList=sonuc.SonucObject;
    })
  }
  KasalariGetir()
  {
    this.bllOrtak.islemWithoutPost("PerakendeKasaList","",false).then(a=>{
      var sonuc=<any>a;
      this.kasalistesi=sonuc.SonucObject;


    })
  }
  Kaydet()
  {
    var formdata=new FormData();
    formdata.append("itemid",this.item.ID.toString());
    formdata.append("durumid",this.item.SonDurum.toString());
    formdata.append("kasaid",this.kasaid.toString());
    formdata.append("islemiyapan",this.aktifkullaniciadi);
    formdata.append("aciklama",this.item.Aciklama);
    this.bllOrtak.islem(formdata,"CekSenetDurumDegistir","",false).then(a=>
      {
        var sonuc=<any>a;
        if(sonuc.Sonuc==1)this.ortak.showBasicAlert("Başarılı","İşlem Başarılı");
        this.Kapat();
        if(sonuc.Sonuc!=1)this.ortak.showBasicAlert("Hata","Beklenmedik bir hata oluştu");
      })
  }
  Kapat()
  {
    this.viewCtrl.dismiss();
  }



}



// WEBPACK FOOTER //
// ./src/pages/CekSenetIslemleri/cek-senet-durum-degistir/cek-senet-durum-degistir.ts